import { render, staticRenderFns } from "./CheckboxCard.vue?vue&type=template&id=f92af40c&scoped=true&"
import script from "./CheckboxCard.vue?vue&type=script&lang=js&"
export * from "./CheckboxCard.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxCard.vue?vue&type=style&index=0&id=f92af40c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92af40c",
  null
  
)

export default component.exports